import { connect } from 'react-redux';
import HeaderView from '../components/header-view';

const mapStateToProps = state => ({
  ganttDimensions: state.gantt.ganttDimensions,
  viewDimensions: state.gantt.viewDimensions,
  dateReference: state.gantt.dateReference,
  lanesInfo: state.gantt.lanesInfo,
  view: state.gantt.view,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderView);
